import { useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { api, AuditLogItem } from "../../lib/api";

export function AuditLogPage() {
  const [actionFilter, setActionFilter] = useState("");
  const { data, isLoading } = useQuery({
    queryKey: ["audit-log", actionFilter],
    queryFn: () => {
      const p = new URLSearchParams();
      if (actionFilter) p.set("action", actionFilter);
      p.set("limit", "100");
      return api.get<{ items: AuditLogItem[]; count: number }>(`/api/v1/admin/audit-log?${p}`);
    },
    refetchInterval: 30_000,
  });

  return (
    <div style={{ padding: "24px 32px" }}>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 16 }}>
        <h1 style={{ fontSize: 22, color: "#1a365d", margin: 0 }}>
          Аудит-лог {data && <span style={{ color: "#718096", fontSize: 14 }}>({data.count})</span>}
        </h1>
        <input
          placeholder="Фільтр action (наприклад user.create)"
          value={actionFilter}
          onChange={(e) => setActionFilter(e.target.value)}
          style={inp}
        />
      </div>

      {isLoading && <div>Завантаження…</div>}

      {data && (
        <div style={{ background: "white", borderRadius: 6, border: "1px solid #e2e8f0", overflow: "hidden" }}>
          <table style={{ width: "100%", borderCollapse: "collapse", fontSize: 12.5 }}>
            <thead>
              <tr style={{ background: "#ebf4ff", textAlign: "left", color: "#2c5282" }}>
                <th style={th}>Час</th><th style={th}>User</th><th style={th}>Дія</th>
                <th style={th}>Object</th><th style={th}>IP</th>
              </tr>
            </thead>
            <tbody>
              {data.items.map((e) => (
                <tr key={e.log_id} style={{ borderTop: "1px solid #e2e8f0" }}>
                  <td style={td}>{new Date(e.created_at).toLocaleString("uk-UA")}</td>
                  <td style={td}><code style={{ fontSize: 11 }}>{e.user_id?.slice(0, 8) || "system"}</code></td>
                  <td style={td}><code>{e.action}</code></td>
                  <td style={td}>{e.object_type ? `${e.object_type}/${e.object_id?.slice(0, 8)}` : "—"}</td>
                  <td style={td}><code style={{ fontSize: 11 }}>{e.ip || "—"}</code></td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}

const th: React.CSSProperties = { padding: "8px 12px", fontWeight: 600 };
const td: React.CSSProperties = { padding: "6px 12px" };
const inp: React.CSSProperties = { padding: "7px 10px", fontSize: 13, border: "1px solid #cbd5e0", borderRadius: 4, width: 260 };
